import React, { useState, Fragment, useEffect } from "react";
import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import Select from "react-select";
import AddTankNameDetails from "./AddTankNameDetails";
import { connect } from "react-redux";
import Spinner from "../layout/Spinner";
import Pagination from "../layout/Pagination";
import { getAllTankName } from "../../actions/area";
import EditTankNameDetails from "./EditTankNameDetails";
const AllTankName = ({
  auth: { allUser, isAuthenticated, user, users },
  area: { allBlock, tankNameData },

  getAllTankName,
  //   getAllBlock,
}) => {
  useEffect(() => {
    getAllTankName();
  }, [tankNameData]);
  //Add
  const [showAddStateModal, setShowAddStateModal] = useState(false);
  const handleAddStateModalClose = () => setShowAddStateModal(false);
  const onClickHandler = () => {
    setShowAddStateModal(true);
  };

  //Edit
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const handleUpdateModalClose = () => setShowUpdateModal(false);
  const [userData, setUserData] = useState(null);
  const onEdit = (tankNames, idx) => {
    setShowUpdateModal(true);
    setUserData(tankNames);
  };

  const onUpdateModalChange = (e) => {
    if (e) {
      handleUpdateModalClose();
    }
  };

  //pagination code
  const [currentData, setCurrentData] = useState(1);
  const [dataPerPage] = useState(8);
  //Get Current Data
  const indexOfLastData = currentData * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentDatas =
    tankNameData && tankNameData.slice(indexOfFirstData, indexOfLastData);
  //change page
  const paginate = (nmbr) => {
    setCurrentData(nmbr);
  };

  //pagination code ends
  return !isAuthenticated || !user || !users ? (
    <Spinner />
  ) : (
    <Fragment>
      <div className="container container_align ">
        <section className="sub_reg">
          <div className="row col-lg-11 col-md-12 col-sm-12 col-12 no_padding">
            <div className="row col-lg-5 col-md-11 col-sm-10 col-10">
              <h5 className="heading_color">All Tank Name </h5>
              <div className="col-lg-5 col-md-11 col-sm-11 col-11">
                {user.userGroupName === "Super Admin" && (
                  <Select
                    name="institutionName"
                    // options={allinstitution}
                    // isSearchable={true}
                    // value={institution}
                    placeholder="Institution"
                    // onChange={(e) => onInstitutionChange(e)}
                    theme={(theme) => ({
                      ...theme,
                      height: 26,
                      minHeight: 26,
                      borderRadius: 1,
                      colors: {
                        ...theme.colors,
                        primary: "black",
                      },
                    })}
                  />
                )}
              </div>
            </div>
            {user.userGroupName !== "Super Admin" && (
              <div className="col-lg-7 col-md-1 col-sm-1 col-1 py-4">
                <img
                  className="img_icon_size log float-right"
                  onClick={() => onClickHandler()}
                  src={require("../../static/images/add-icon.png")}
                  alt="Add TankName"
                  title="Add TankName"
                />
              </div>
            )}
          </div>

          <div className="row">
            <div className="col-lg-11 col-md-12 col-sm-12 col-12 text-center py-2">
              <section className="body">
                <div className=" body-inner no-padding table-responsive">
                  <table
                    className="table table-bordered table-striped table-hover"
                    id="datatable2"
                  >
                    <thead>
                      <tr>
                        <th>Tank Name</th>
                        {/* <th>District</th> */}
                        {user.userGroupName !== "Super Admin" && <th>Op</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {currentDatas &&
                        currentDatas.map((tankNameData, idx) => {
                          return (
                            <tr key={idx}>
                              <td>{tankNameData.tankName}</td>
                              {/* <td>
                                {allBlock &&
                                  allBlock.output[0] &&
                                  allBlock.output[0].districtName}
                              </td> */}
                              {user.userGroupName !== "Super Admin" && (
                                <td>
                                  {/* <img
                                    className="img_icon_size log"
                                    onClick={() => onUpdate(districtData, idx)}
                                    src={require("../../static/images/delete.png")}
                                    alt="Deactivate"
                                    title="Deactivate"
                                  />{" "} */}
                                  &nbsp;
                                  <img
                                    className="img_icon_size log"
                                    onClick={() => onEdit(tankNameData, idx)}
                                    src={require("../../static/images/edit_icon.png")}
                                    alt="Edit TankName"
                                    title="Edit TankName"
                                  />
                                </td>
                              )}
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 no_padding">
                    {tankNameData && tankNameData.length !== 0 ? (
                      <Pagination
                        dataPerPage={dataPerPage}
                        totalData={tankNameData.length}
                        paginate={paginate}
                        currentPage={currentData}
                      />
                    ) : (
                      <Fragment />
                    )}
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12 align_right">
                    <label>
                      No. of Tank Names : {tankNameData && tankNameData.length}
                    </label>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
        <Modal
          show={showAddStateModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Add Tank Name Details</h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleAddStateModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <AddTankNameDetails
              setShowAddStateModal={setShowAddStateModal}

              //   onAddDistrictModalChange={onAddDistrictModalChange}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={showUpdateModal}
          backdrop="static"
          keyboard={false}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">
                Edit Tank Name Details{" "}
              </h3>
            </div>
            <div className="col-lg-2">
              <button onClick={handleUpdateModalClose} className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <EditTankNameDetails
              tankNames={userData}
              setShowUpdateModal={setShowUpdateModal}
            />
          </Modal.Body>
        </Modal>

        <Modal
        //   show={showDeactiveModal}
        //   backdrop="static"
        //   keyboard={false}
        //   size="md"
        //   aria-labelledby="contained-modal-title-vcenter"
        //   centered
        >
          {/* <Modal.Header>
            <div className="col-lg-10">
              <h3 className="modal-title text-center">Deactivate Tank Name</h3>
            </div>
            <div className="col-lg-2">
              <button className="close">
                <img
                  src={require("../../static/images/close.png")}
                  alt="X"
                  style={{ height: "20px", width: "20px" }}
                />
              </button>
            </div>
          </Modal.Header> */}
          {/* <Modal.Body>
            <DeactiveBlock
              districtData={userDatas}
              onDeactiveModalChange={onDeactiveModalChange}
            />
          </Modal.Body> */}
        </Modal>
      </div>
    </Fragment>
  );
};

AllTankName.propTypes = {
  auth: PropTypes.object.isRequired,
  area: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
  getAllTankName: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  area: state.area,
  shg: state.shg,
});

export default connect(mapStateToProps, {
  getAllTankName,
  //   getStates,
})(AllTankName);
